<template>
  <content-section title="Информация о численности обучающихся за 2024 год">
    <content-table
        :columns="columns"
        :rows="rows"
    />
  </content-section>
</template>

<script>
import ContentSection from "@/components/content/ContentSection.vue";
import ContentTable from "@/components/content/ContentTable.vue";

export default {
  name: 'ContentStudentStatsTable',
  components: { ContentSection, ContentTable },
  computed: {
    columns() {
      return [
        [
          { title: 'Уровень образования', rowspan: 2 },
          { title: 'Формы обучения', rowspan: 2 },
          { title: 'Всего обученных', rowspan: 2 },
          { title: 'Сведения о численности обучающихся за счет (количество человек):', colspan: 4 },
          { title: 'Численность обучающихся, являющихся иностранными гражданами', rowspan: 2 }
        ],
        [
          'бюджетных ассигнований федерального бюджета',
          'бюджетов субъектов Российской Федерации',
          'местных бюджетов',
          'средств физических и (или) юридических лиц'
        ]
      ];
    },
    rows() {
      return [
        [
          'Программы повышения подготовки',
          'Очная, очно-заочная, заочная',
          760,
          445,
          0,
          0,
          315,
          0
        ],
        [
          'Программы профессиональной переподготовки',
          '',
          0,
          0,
          0,
          0,
          0,
          0
        ]
      ];
    }
  }
}
</script>
